import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import theme from '../theme'

const CircularLoader = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette['accent-500']
      }}
    >
      <CircularProgress color="inherit" />
    </Box>
  )
}

export default CircularLoader
